
// * ========================================================================
// * newPerDay chart and table
// * ========================================================================

import moment from 'moment';
import CovidChart from './covid-chart.js';
import { Tooltip } from 'chart.js';

Tooltip.positioners.myCustomPositioner = function(elements, eventPosition) {
    const tooltipWidth = 300;
    const tooltipWidthHalf = (tooltipWidth / 2);
    let x = eventPosition.x - tooltipWidthHalf;

    if (eventPosition.x < (tooltipWidth + 30)) {
        x = tooltipWidthHalf + 30;
    }

    return {
        x: x,
        y: 10
    };
};


const newPerDay = (function(){
    let thisChart = null;

    const average = (arr) => arr.reduce((a, b) => a + b) / arr.length;

    /**
     *
     * Create new chart
     *
     * @param {Object} data - covid data
     * @param {Object} options - chart options
     *
     * @returns {Object} - chart
     */
    function createChartData(data, options) {
        let datasets = [{
            label: 'Yhteensä',
            id: 'all',
            type: 'LineWithLine',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 3,
            count: 0,
            fill: true,
            backgroundColor: 'rgba(0,0,0,0.1)',
            data: [],
            pointRadius: 0,
            cubicInterpolationMode: 'default',
            lineTension: 0.6
        }, {
            label: '7 päivän keskiarvo',
            id: 'average',
            type: 'LineWithLine',
            fill: false,
            backgroundColor: '#000000',
            borderColor: '#000000',
            borderWidth: 2,
            data: [],
            pointRadius: 0,
            cubicInterpolationMode: 'default',
            lineTension: 0.6,
            showAlways: true
        }];

        const areaData = {};
        let maxCount = 0;

        for (let idx = 0; idx < data.days.length; idx++) {
            const item = data.days[idx];
            const date = moment(item.date);

            // Push only after first visible date
            if (date >= options.firstDate) {
                maxCount = item.dayCount > maxCount ? item.dayCount : maxCount;

                // Add to total count
                datasets[0].data.push({
                    x: date,
                    y: item.dayCount
                });

                for (let area of data.areaDays[idx].areas) {
                    const areaId = data.areas[area.index].id;

                    if (typeof areaData[areaId] === 'undefined') {
                        areaData[areaId] = []; // Array of counts for each day
                    }

                    areaData[areaId].push({
                        x: date,
                        y: area.dayCount
                    });
                }

                // Get past 7 days values
                let firstDay = idx - 7;
                firstDay = firstDay < 0 ? 0 : firstDay;

                if (idx > 0) {
                    //if (date < averageLastDay) {
                    const pastWeekValues = [];
                    for (let x = firstDay; x < idx; x++) {
                        let dayValue = data.days[x];
                        pastWeekValues.push(dayValue.dayCount);
                    }
                    const weekAverage = Math.round(average(pastWeekValues));
                    datasets[1].data.push({
                        x: date,
                        y: weekAverage
                    });
                } else {
                    datasets[1].data.push({
                        x: date,
                        y: item.dayCount
                    });
                }

            }
        }

        const areaDatasets = data.areas.map(function (area, index) {
            return {
                label: area.name,
                id: area.id,
                data: areaData[area.id],
                type: 'bar',
                backgroundColor: options.chartColors[index],
                barPercentage: 1,
                yAxisID: 'bar-stacked'
            }
        });

        datasets = datasets.concat(areaDatasets);

        const initialMax = ((parseInt(maxCount / 10, 10) + 1) * 10) + 40;

        return { datasets, initialMax };
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        const { datasets, initialMax } = createChartData(data.confirmed, window.config);

        thisChart = new CovidChart('new-line-chart', {
            type: 'bar',
            datasets,
            chartOptions: {
                options: {
                    plugins: {
                        legend: {
                            display: true,
                        },
                        tooltip: {
                            //position: 'nearest',
                            position: 'myCustomPositioner',
                            bodySpacing: 5,
                            callbacks: {
                                label: function(tooltipItem) {
                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + tooltipItem.formattedValue;

                                    return label;
                                }
                            },
                            itemSort: function(a, b, data) {
                                if (b.datasetIndex === 0) {
                                    return 1;
                                } else if (b.datasetIndex === 1) {
                                    if (a.datasetIndex === 0) {
                                        return -1;
                                    }
                                    return 1;
                                }

                                return b.yLabel > a.yLabel ? 1 : -1;
                            },
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            stacked: true,
                            offset: true,
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M',
                                }
                            }
                        },
                        y: {
                            display: false,
                            stacked: false,
                            min: 0,
                            max: initialMax,
                            ticks: {
                                precision: 0
                            }
                        },
                        'bar-stacked': {
                            stacked: true,
                            axis: 'y',
                            min: 0,
                            max: initialMax,
                            ticks: {
                                precision: 0
                            }
                        }
                    }
                }
            },
            delayAnnotation: true,
            config: window.config,
            responsive: ['aspectRatio','legend','annotation'],
            tooltips: {
                elementId: 'new-cases-per-day-chart-tooltip',
                highlightFirstIndex: true,
                hideHighlight: true
            },
            multiselect: {
                requireCount: false,
                selectAll: true,
                valueType: 'string',
                idField: 'id',
                colorField: 'borderColor',
                inputName: 'new-per-day-multiselect',
                selectElemId: 'new-per-day-multiselect',
                //colorElemId: 'new-per-day-multiselect-colors',
                countElemId: 'new-per-day-multiselect-count',
                selectAllElemId: 'new-per-day-multiselect-select-all',
                clearAllElemId: 'new-per-day-multiselect-clear-all',
            }
        });
    }

    function reload(data) {
        const { datasets, initialMax } = createChartData(data.confirmed, window.config);

        // Update initialMax
        thisChart.chart.options.scales.y.ticks.max = initialMax;
        thisChart.chart.options.scales['bar-stacked'].ticks.max = initialMax;

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default newPerDay;
